module.exports = __webpack_public_path__ + "static/media/cupcake-mustache.521f2479.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2017-11-4/cupcake-mustache.jpg
// module id = 800
// module chunks = 0